import { createContext, useContext } from 'react';

export const PartyManagerContext = createContext(null);

export const usePartyManager = () => {
  const context = useContext(PartyManagerContext);
  if (!context) {
    throw new Error(
      'usePartyManager must be used within a PartyManagerProvider',
    );
  }
  return context;
};
